// extracted by mini-css-extract-plugin
export default {"button":"styles_button__2JbvW","checkBox":"styles_checkBox__3bLVV","checked":"styles_checked__+M7yv"};